import { Navigate, Routes, Route, Outlet } from 'react-router-dom';
import { PageLink, PageTitle } from '../../../_metronic/layout/core';
import NauphilusReportList from './NauphilusReportList';



const ReportPageNauphilus = () => {
  const userBreadCrumbs: Array<PageLink> = [
    {
      title: 'Reportes',
      path: 'nauphilus-reports/',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='list'
          element={
            <>
              <NauphilusReportList />
              <PageTitle breadcrumbs={userBreadCrumbs}>
                Reporte de Auditoría de Entrevistas
              </PageTitle>
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='list' />} />
    </Routes>
  );
};

export default ReportPageNauphilus;
